import { render, staticRenderFns } from "./ItemConfirmation.vue?vue&type=template&id=3db47413&"
import script from "./ItemConfirmation.vue?vue&type=script&lang=js&"
export * from "./ItemConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports